import { render } from "./PhoneIcon.vue?vue&type=template&id=4c116f1e&scoped=true"
import script from "./PhoneIcon.vue?vue&type=script&lang=js"
export * from "./PhoneIcon.vue?vue&type=script&lang=js"

import "./PhoneIcon.vue?vue&type=style&index=0&id=4c116f1e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c116f1e"]])

export default __exports__